import script from "./VWMA.vue?vue&type=script&lang=js"
export * from "./VWMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__